import { Box, Button, Container, Paper, Stack, Typography, useTheme, alpha } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CalculateIcon from '@mui/icons-material/Calculate';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';
import { PRICES } from '../../data/modules';
import { moduleColors } from '../../theme';

const rows = [
  { label: 'Solvenda Internet', price: `€${PRICES.internet}`, suffix: '/mo · Radius Manager (DMA)', color: moduleColors.core },
  { label: 'SolvendaRadius', price: `€${PRICES.radius}`, suffix: '/mo · replaces Internet', color: moduleColors.radius },
  { label: 'IPTV — Stalker Portal', price: `€${PRICES.iptv}`, suffix: '/mo', color: moduleColors.core },
  { label: 'IPTV — Xtream Codes', price: `€${PRICES.iptv}`, suffix: '/mo', color: moduleColors.core },
  { label: 'DVB-C', price: `€${PRICES.dvbc}`, suffix: '/mo · Conax encryption', color: moduleColors.core },
  { label: 'Fiscalization', price: `€${PRICES.fiscal}`, suffix: '/mo', color: moduleColors.fiscal },
  { label: 'Solvenda DNS', price: `€${PRICES.dns}`, suffix: '/mo', color: moduleColors.dns },
  { label: 'Logs History', price: `€${PRICES.logs}`, suffix: '/mo · legal retention', color: moduleColors.logs },
  { label: 'OLT Management', price: `€${PRICES.olt}`, suffix: '/mo per OLT', color: moduleColors.olt },
  { label: 'SolvendaConnect', price: '€0', suffix: '/mo · pay per transaction', color: moduleColors.connect },
];

const PricingSection = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.paper' }}>
      <Container>
        <SectionHeading
          overline="Simple, transparent pricing"
          title="Only pay for what you use"
          subtitle="Every module priced clearly, with no setup fee. Build your exact plan and see the monthly total instantly."
        />

        <Reveal>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 4,
              p: { xs: 3, md: 4 },
              border: '1px solid',
              borderColor: 'divider',
              maxWidth: 760,
              mx: 'auto',
            }}
          >
            <Stack divider={<Box sx={{ height: '1px', bgcolor: 'divider' }} />} spacing={0}>
              {rows.map((r) => (
                <Box
                  key={r.label}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.75 }}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: r.color }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      {r.label}
                    </Typography>
                  </Stack>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography component="span" variant="h6" sx={{ color: r.color, fontWeight: 800 }}>
                      {r.price}
                    </Typography>{' '}
                    <Typography component="span" variant="body2" color="text.secondary">
                      {r.suffix}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Stack>

            <Box
              sx={{
                mt: 3,
                p: 2,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.08),
                textAlign: 'center',
              }}
            >
              <Typography variant="body2" color="text.secondary">
                SolvendaRadius replaces the normal Internet module — most ISPs pick
                one engine, not both.
              </Typography>
            </Box>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 3, justifyContent: 'center' }}>
              <Button
                component={Link}
                to="/pricing"
                variant="contained"
                color="primary"
                size="large"
                startIcon={<CalculateIcon />}
              >
                Build your plan
              </Button>
              <Button
                component={Link}
                to="/pricing"
                variant="outlined"
                color="primary"
                size="large"
                endIcon={<ArrowForwardIcon />}
              >
                See full pricing
              </Button>
            </Stack>
          </Paper>
        </Reveal>
      </Container>
    </Box>
  );
};

export default PricingSection;
